import moment from "moment";
import { JobStatusT, JobStatusTStrings, JobTypeTStrings } from "../../types/Job";
import unfulfilledInitial from '../../assets/images/unfulfilled-initial.png';
import unfulfilledIntermediate from '../../assets/images/unfulfilled-intermediate.png';
import unfulfilledFinal from '../../assets/images/unfulfilled-final.png';
import scheduledInitial from '../../assets/images/scheduled-initial.png';
import scheduledIntermediate from '../../assets/images/scheduled-intermediate.png';
import scheduledFinal from '../../assets/images/scheduled-final.png';
import completedAddress from '../../assets/images/completed-Initial-address.png';
import completedIntermediate from '../../assets/images/completed-intermediate.png';
import completedFinal from '../../assets/images/completed-Initial-final.png';
import muscleImg from '../../assets/images/muscle.png';
import pickupImg from '../../assets/images/pickup.png';
import toolsImg from '../../assets/images/tools.png';

const colorsNames = {
    "unfulfilled": ["#ff4d2e", "#ad7774", "#f1523f"],
    "scheduled": ["#ceb942", "#fafd2f", "#d0d335"],
    "Scheduled_not_three_days": ["#efae13", "#ffc574", "#fd9600"],
    "completed": ["#18b412", "#00cf3b", "#00ba70"],
    "blue": ["#1919ff", "#1919ffb3", "#1919ff66"],
}

const ColorJobStatusImages = {
    inquiring: {
        PathImage: [unfulfilledInitial, unfulfilledIntermediate, unfulfilledFinal]
    },
    scheduled: {
        PathImage: [unfulfilledInitial, unfulfilledIntermediate, unfulfilledFinal]
    },
    scheduledNotThreeDays: {
        PathImage: [scheduledInitial, scheduledIntermediate, scheduledFinal]
    },
    missed: {
        PathImage: [unfulfilledInitial, unfulfilledIntermediate, unfulfilledFinal]
    },
    spam: {
        PathImage: [completedAddress, completedIntermediate, completedFinal]
    },
    completed: {
        PathImage: [completedAddress, completedIntermediate, completedFinal
        ]

    }

}


const IconJobType = {
    moving_labor: {
        PathImage: muscleImg,
        Icon: 'truck',
        IconClass: 'IconFontAwesome'
    },
    intrastate_local: {
        PathImage: pickupImg,
        Icon: 'truck',
        IconClass: 'IconFontAwesome'
    },
    intrastate_long: {
        PathImage: pickupImg,
        Icon: 'truck',
        IconClass: 'IconFontAwesome'
    },
    interstate: {
        PathImage: pickupImg,
        Icon: 'truck',
        IconClass: 'IconFontAwesome'
    },
    international: {
        PathImage: toolsImg,
        Icon: 'ios-hammer',
        IconClass: 'Ionicons'
    },
    'Other': {
        PathImage: toolsImg,
        Icon: 'ios-hammer',
        IconClass: 'Ionicons'
    },
};
const ColorJobStatus = {
    inquiring: colorsNames.blue,
    scheduled: colorsNames.scheduled,
    scheduledNotThreeDays: colorsNames.Scheduled_not_three_days,
    completed: colorsNames.completed,
    canceled: colorsNames.unfulfilled,
    spam: colorsNames.unfulfilled,
    missed: colorsNames.unfulfilled
}

const getDiffDate = (dateTime: string) => {
    var then = dateTime;
    let dateNow = moment(new Date());
    var ms = moment(dateNow, "YYYY-MM-DD").diff(moment(then, "YYYY-MM-DD"));
    var d = moment.duration(ms);

    return parseInt(`${d.asDays()}`);
}

interface ResultT {
    ImageJobStatus: string,
    ImageJobType: string,
    bgColor: string,
}


export const getPinJobA = (jobStatus: JobStatusTStrings, jobType: JobTypeTStrings, jobDate: string, index: number): ResultT => {
    let result = {
        ImageJobStatus: '',
        ImageJobType: "",
        bgColor: '#ff5034',

    };

    try {
        if (index > 3) {
            index = 0
        }

        let _jobColor = ColorJobStatus[jobStatus];
        result.bgColor = _jobColor[index];
        result.ImageJobType = IconJobType[jobType].PathImage;
        result.ImageJobStatus = ColorJobStatusImages[jobStatus].PathImage[index] ? ColorJobStatusImages[jobStatus].PathImage[index] : "";
        /*
        / 
        */
        if (jobStatus === JobStatusT.scheduled) {
            let diff_day = 0
            if (jobDate != null) {
                diff_day = getDiffDate(jobDate);
            }


            if (diff_day > 3) {
                result.ImageJobStatus = ColorJobStatusImages['Scheduled_not_three_days'].PathImage[index];
            }
        }
    
        return result;
    } catch (error) {
        console.log("error->PinMarkerJobs: " + error + ":" + JSON.stringify(jobType))
        return result
    }
    return result
}
